export default "__VITE_ASSET__Bkg2qtUN__"